"use strict";

require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.find-index.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _interface = require("../interface");
var _classnames = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../../_utils/hooks/usePrefixCls");
var _excluded = ["size", "color", "className", "style"]; // GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
/* eslint-disable */
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CloseIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('icon');
  var size = props.size,
    color = props.color,
    className = props.className,
    customStyle = props.style,
    restProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var isFontSize = false;
  var isSize = false;
  if (typeof size === 'number') {
    isFontSize = true;
  } else {
    isSize = _interface.SizeTypes.findIndex(function (item) {
      return item === size;
    }) !== -1;
  }
  var classes = (0, _classnames.default)(prefixCls, prefixCls + '--' + 'close', (0, _defineProperty2.default)({}, 'size-' + size, isSize), className);
  var style = _objectSpread({
    color: color,
    fontSize: isFontSize ? size : undefined
  }, customStyle);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    ref: ref,
    className: classes,
    style: style
  }, restProps, {
    height: "16px",
    width: "16px",
    version: "1.1",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/_react.default.createElement("title", null, "\u753B\u677F"), /*#__PURE__*/_react.default.createElement("g", {
    id: "\u753B\u677F",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, /*#__PURE__*/_react.default.createElement("path", {
    id: "\u8DEF\u5F84",
    d: "M4.2071225,2.7929025 C3.8165925,2.4023825 3.1834325,2.4023825 2.7929025,2.7929025 C2.4023825,3.1834325 2.4023825,3.8165925 2.7929025,4.2071225 L6.5858025,8.0000125 L2.7929025,11.7929125 C2.4023825,12.1834125 2.4023825,12.8166125 2.7929025,13.2071125 C3.1834325,13.5976125 3.8165925,13.5976125 4.2071225,13.2071125 L8.0000125,9.4142225 L11.7929125,13.2071125 C12.1834125,13.5976125 12.8166125,13.5976125 13.2071125,13.2071125 C13.5976125,12.8166125 13.5976125,12.1834125 13.2071125,11.7929125 L9.4142225,8.0000125 L13.2071125,4.2071225 C13.5976125,3.8165925 13.5976125,3.1834325 13.2071125,2.7929025 C12.8166125,2.4023825 12.1834125,2.4023825 11.7929125,2.7929025 L8.0000125,6.5858025 L4.2071225,2.7929025 Z",
    fill: "currentColor"
  })));
});
var _default = CloseIcon;
exports.default = _default;